import React, { useState, useEffect } from "react";
import ContactVendorleadsModal from "../../components/ContactVendorleadsModal";
import SignInModal from "../../components/SignInModal";
import Navbar from "../../components/Navbar";

const BRAND_COLOR = "#1a3f6b";
const BRAND_ACCENT_COLOR = "#10b981";
const BRAND_BLUE = "#3b82f6";
const GRAY_DARK_COLOR = "#374151";

const DEMO_AGENCY = {
  agency_name: "Demo Agency",
  agent_name: "John Doe",
  agent_first_name: "John",
  agent_title: "Licensed Agent",
  agent_email: "bayan+demo@vendorleads.com.au",
  agent_phone: "0400 000 000",
  landing_page_slug: "demo-agency",
  logo_url:
    "https://realestate-reports-assets.s3.us-west-2.amazonaws.com/agencies/demo-agency/logo_url_1774836185_14b54735.png",
  profile_image_url:
    "https://realestate-reports-assets.s3.us-west-2.amazonaws.com/agencies/demo-agency/profile-image.jpg",
};

const ARTICLE_LIBRARY = [
  {
    badge: "SALES SNAPSHOT",
    badgeColor: "#3b82f6",
    cover:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=900&q=70",
    title: "Manly Property Market Update, March 2026",
    snippet:
      "Median house values climb to $4.62M while rental demand surges on tightening vacancy.",
    suburb: "Manly NSW",
    minutes: 4,
    views: 312,
    pitch: [
      "Monthly pulse on prices, sales volume and growth",
      "Positions you as the agent tracking the data",
      "Perfect for your database and Friday social post",
    ],
  },
  {
    badge: "RENTAL TRENDS",
    badgeColor: "#10b981",
    cover:
      "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=900&q=70",
    title: "Why Mosman Rents Climbed 9.4% This Quarter",
    snippet:
      "A vacancy rate under 1.5% is pushing yields higher and pulling new investor stock into the market.",
    suburb: "Mosman NSW",
    minutes: 3,
    views: 184,
    pitch: [
      "Yields, vacancy and rent growth made readable",
      "Targets landlords deciding to hold, sell or buy more",
      "Surfaces investor leads from your database",
    ],
  },
  {
    badge: "SUBURB PROFILE",
    badgeColor: "#8b5cf6",
    cover:
      "https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=900&q=70",
    title: "Balmain: An Inner West Pocket Quietly Outperforming",
    snippet:
      "Schools, ferries and a wave of renovations are reshaping who's buying, and what they'll pay.",
    suburb: "Balmain NSW",
    minutes: 5,
    views: 426,
    pitch: [
      "Demographics, schools, transport and lifestyle",
      "Pulls in buyers researching the move",
      "Great share piece for prospective sellers' partners",
    ],
  },
  {
    badge: "INFRASTRUCTURE",
    badgeColor: "#f59e0b",
    cover:
      "https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&w=900&q=70",
    title: "Three Projects About to Lift Values Across the Lower North Shore",
    snippet:
      "The Beaches Link, the Western Harbour Tunnel and the new ferry wharves are converging on the same postcodes.",
    suburb: "Neutral Bay NSW",
    minutes: 6,
    views: 538,
    pitch: [
      "Projects shaping future value, explained simply",
      "Gives sellers a reason to act now",
      "Gives buyers a reason to compete harder",
    ],
  },
  {
    badge: "TOP PERFORMERS",
    badgeColor: "#ec4899",
    cover:
      "https://images.unsplash.com/photo-1582407947304-fd86f028f716?auto=format&fit=crop&w=900&q=70",
    title: "Top 5 Streets in Vaucluse by Median Sale Price",
    snippet:
      "Three of them you'd expect. Two of them surprised us, and they're outperforming the suburb by 14%.",
    suburb: "Vaucluse NSW",
    minutes: 4,
    views: 271,
    pitch: [
      "Best streets and standout sales of the quarter",
      "The article every homeowner wants about their street",
      "High share rate among curious neighbours",
    ],
  },
  {
    badge: "MARKET UPDATE",
    badgeColor: "#0ea5e9",
    cover:
      "https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=900&q=70",
    title: "Double Bay: Days on Market Drop to 18",
    snippet:
      "Buyer urgency is back. Stock is moving in under three weeks for the first time since spring.",
    suburb: "Double Bay NSW",
    minutes: 3,
    views: 209,
    pitch: [
      "Weekly pulse on what changed in the market",
      "Keeps subscribers opening the next one",
      "Light read, perfect for an SMS or email blast",
    ],
  },
];

const TOPIC_CARDS = [
  { icon: "📈", label: "Sales activity", desc: "Median prices, volumes, growth" },
  { icon: "🔑", label: "Rental trends", desc: "Yields, vacancy, demand" },
  { icon: "📍", label: "Suburb profiles", desc: "Demographics, schools, transport" },
  { icon: "🏗️", label: "Infrastructure", desc: "Projects shaping value" },
  { icon: "🏆", label: "Top performers", desc: "Best streets and sales" },
  { icon: "🏘️", label: "Your listings", desc: "Articles built around your stock" },
];

function GlobalAnimations() {
  return (
    <style>{`
      @keyframes fadeUp {
        0%   { opacity: 0; transform: translateY(10px); }
        100% { opacity: 1; transform: translateY(0); }
      }
      @keyframes fadeIn {
        0%   { opacity: 0; }
        100% { opacity: 1; }
      }
      @keyframes slideInRight {
        0%   { opacity: 0; transform: translateX(20px); }
        100% { opacity: 1; transform: translateX(0); }
      }
      @keyframes slideInDown {
        0%   { opacity: 0; transform: translateY(-12px); }
        100% { opacity: 1; transform: translateY(0); }
      }
      @keyframes slideInUp {
        0%   { opacity: 0; transform: translateY(16px); }
        100% { opacity: 1; transform: translateY(0); }
      }
      @keyframes pulseDot {
        0%, 100% { box-shadow: 0 0 0 0 rgba(16,185,129,0.45); }
        50%      { box-shadow: 0 0 0 10px rgba(16,185,129,0); }
      }
      @keyframes pinPulse {
        0%   { transform: translate(-50%, -50%) scale(1); opacity: 0.7; }
        100% { transform: translate(-50%, -50%) scale(2.8); opacity: 0; }
      }
      @keyframes pinDrop {
        0%   { transform: translate(-50%, -130%) scale(0.6); opacity: 0; }
        60%  { transform: translate(-50%, -95%) scale(1.05); opacity: 1; }
        100% { transform: translate(-50%, -100%) scale(1); opacity: 1; }
      }
      @keyframes caret {
        0%, 50%  { opacity: 1; }
        51%, 100% { opacity: 0; }
      }
      @keyframes barGrow {
        0%   { transform: scaleY(0.05); }
        100% { transform: scaleY(1); }
      }
      @keyframes shimmer {
        0%   { background-position: -200% 0; }
        100% { background-position: 200% 0; }
      }
      @keyframes countTick {
        0%   { transform: translateY(0); }
        50%  { transform: translateY(-2px); }
        100% { transform: translateY(0); }
      }
      @keyframes wiggle {
        0%, 100% { transform: rotate(0deg); }
        25%      { transform: rotate(-6deg); }
        75%      { transform: rotate(6deg); }
      }
      @keyframes scroll-x {
        0%   { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
      @keyframes ringPing {
        0%   { transform: scale(0.6); opacity: 0.9; }
        100% { transform: scale(2.4); opacity: 0; }
      }
      @keyframes searchSlide {
        0%   { transform: translateY(12px); opacity: 0; }
        100% { transform: translateY(0); opacity: 1; }
      }
      @keyframes orbitGlow {
        0%, 100% { box-shadow: 0 0 20px rgba(16,185,129,0.35), 0 0 60px rgba(59,130,246,0.18); }
        50%      { box-shadow: 0 0 30px rgba(16,185,129,0.55), 0 0 80px rgba(59,130,246,0.28); }
      }
    `}</style>
  );
}

/* ─────────── Hero: AI writing demo ─────────── */
function AIWritingHero({ isMobile }) {
  const [typed, setTyped] = useState("");
  const [phase, setPhase] = useState("title");
  const titleTarget = "Manly Property Market Update, March 2026";
  const bodyTarget =
    "Median house values climbed to $4.62M this quarter while rental demand surged on a tightening 1.1% vacancy rate. Three confirmed coastal precinct upgrades are forecast to lift values across Fairlight and Queenscliff over the next 18 months. For homeowners, the data points to one clear conclusion: equity is quietly building, and timing matters.";

  useEffect(() => {
    let i = 0;
    let cancelled = false;
    const target = phase === "title" ? titleTarget : bodyTarget;
    const speed = phase === "title" ? 38 : 14;
    const tick = () => {
      if (cancelled) return;
      i++;
      setTyped(target.slice(0, i));
      if (i >= target.length) {
        if (phase === "title") {
          setTimeout(() => {
            if (cancelled) return;
            setPhase("body");
            setTyped("");
          }, 700);
        } else {
          setTimeout(() => {
            if (cancelled) return;
            setPhase("title");
            setTyped("");
          }, 3500);
        }
        return;
      }
      setTimeout(tick, speed + (Math.random() < 0.1 ? 80 : 0));
    };
    const start = setTimeout(tick, 350);
    return () => {
      cancelled = true;
      clearTimeout(start);
    };
  }, [phase]);

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 16,
        overflow: "hidden",
        border: "1px solid rgba(255,255,255,0.12)",
        boxShadow: "0 30px 80px rgba(0,0,0,0.35)",
        animation: "orbitGlow 4s ease-in-out infinite",
      }}
    >
      <div
        style={{
          background: "#f1f5f9",
          padding: "10px 14px",
          display: "flex",
          alignItems: "center",
          gap: 8,
          borderBottom: "1px solid #e2e8f0",
        }}
      >
        <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#fca5a5" }} />
        <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#fcd34d" }} />
        <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#86efac" }} />
        <div
          style={{
            marginLeft: 8,
            background: "#fff",
            borderRadius: 6,
            padding: "4px 12px",
            fontSize: 11,
            color: "#64748b",
            fontFamily: "ui-monospace, SFMono-Regular, monospace",
            border: "1px solid #e2e8f0",
            flex: 1,
            minWidth: 0,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          vendorleads.com.au/articles/generate
        </div>
      </div>
      <div style={{ padding: isMobile ? 18 : 22, minHeight: isMobile ? 360 : 420 }}>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            background: "rgba(16,185,129,0.1)",
            border: "1px solid rgba(16,185,129,0.3)",
            color: BRAND_ACCENT_COLOR,
            fontSize: 10.5,
            fontWeight: 800,
            letterSpacing: 1,
            padding: "4px 10px",
            borderRadius: 999,
            marginBottom: 14,
            textTransform: "uppercase",
          }}
        >
          <span
            style={{
              width: 7,
              height: 7,
              borderRadius: "50%",
              background: BRAND_ACCENT_COLOR,
              animation: "pulseDot 1.4s ease-out infinite",
            }}
          />
          AI writing · Manly NSW
        </div>

        <div
          style={{
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: 1.2,
            color: "#94a3b8",
            textTransform: "uppercase",
            marginBottom: 5,
          }}
        >
          Title
        </div>
        <div
          style={{
            minHeight: 56,
            fontSize: isMobile ? 17 : 20,
            fontWeight: 800,
            color: "#0f172a",
            lineHeight: 1.3,
            marginBottom: 16,
          }}
        >
          {phase === "title" ? typed : titleTarget}
          {phase === "title" && (
            <span
              style={{
                display: "inline-block",
                width: 2,
                height: 18,
                background: BRAND_BLUE,
                verticalAlign: "middle",
                marginLeft: 2,
                animation: "caret 0.9s steps(1) infinite",
              }}
            />
          )}
        </div>

        <div
          style={{
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: 1.2,
            color: "#94a3b8",
            textTransform: "uppercase",
            marginBottom: 5,
          }}
        >
          Article body
        </div>
        <div
          style={{
            fontSize: 13,
            color: "#334155",
            lineHeight: 1.7,
            minHeight: 160,
          }}
        >
          {phase === "body" ? typed : ""}
          {phase === "body" && (
            <span
              style={{
                display: "inline-block",
                width: 2,
                height: 14,
                background: BRAND_BLUE,
                verticalAlign: "middle",
                marginLeft: 2,
                animation: "caret 0.9s steps(1) infinite",
              }}
            />
          )}
        </div>

        <div
          style={{
            marginTop: 16,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 8,
            paddingTop: 12,
            borderTop: "1px dashed #e2e8f0",
          }}
        >
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            {["Suburb trends", "Sales data", "Vacancy"].map((t) => (
              <span
                key={t}
                style={{
                  fontSize: 10,
                  fontWeight: 700,
                  color: "#64748b",
                  background: "#f1f5f9",
                  padding: "3px 8px",
                  borderRadius: 999,
                }}
              >
                {t}
              </span>
            ))}
          </div>
          <div
            style={{
              fontSize: 10,
              fontWeight: 700,
              color: BRAND_ACCENT_COLOR,
              letterSpacing: 0.5,
            }}
          >
            {phase === "title" ? "drafting headline…" : "writing body…"}
          </div>
        </div>
      </div>
    </div>
  );
}

/* ─────────── Animated article card (flips on click/hover) ─────────── */
function ArticleCard({ article, delay = 0, agentColor = BRAND_COLOR, animate = true }) {
  const [views, setViews] = useState(article.views);
  const [flipped, setFlipped] = useState(false);
  const [hovered, setHovered] = useState(false);
  useEffect(() => {
    const t = setInterval(() => {
      if (Math.random() < 0.55) setViews((v) => v + 1);
    }, 1200 + Math.random() * 1800);
    return () => clearInterval(t);
  }, []);

  const showBack = flipped || hovered;

  const faceStyle = {
    position: "absolute",
    inset: 0,
    backfaceVisibility: "hidden",
    WebkitBackfaceVisibility: "hidden",
    borderRadius: 14,
    overflow: "hidden",
    border: "1px solid #e2e8f0",
    boxShadow: "0 6px 20px rgba(15,23,42,0.06)",
    background: "#fff",
    display: "flex",
    flexDirection: "column",
  };

  return (
    <div
      style={{
        perspective: 1200,
        animation: animate ? `slideInUp 0.6s ${delay}ms ease both` : undefined,
        cursor: "pointer",
      }}
      onClick={() => setFlipped((f) => !f)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          paddingBottom: "96%",
          transformStyle: "preserve-3d",
          transform: showBack ? "rotateY(180deg)" : "rotateY(0deg)",
          transition: "transform 0.6s cubic-bezier(.2,.7,.3,1)",
        }}
      >
        {/* FRONT */}
        <div style={faceStyle}>
          <div
            style={{
              position: "relative",
              width: "100%",
              paddingTop: "56%",
              background: "#e5e7eb",
              flexShrink: 0,
            }}
          >
            <img
              src={article.cover}
              alt={article.title}
              style={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
            <span
              style={{
                position: "absolute",
                top: 10,
                left: 10,
                fontSize: 9.5,
                fontWeight: 800,
                color: "#fff",
                background: article.badgeColor,
                padding: "3px 8px",
                borderRadius: 4,
                letterSpacing: 0.8,
              }}
            >
              {article.badge}
            </span>
            <span
              style={{
                position: "absolute",
                bottom: 10,
                right: 10,
                fontSize: 10,
                fontWeight: 700,
                color: "#fff",
                background: "rgba(15,23,42,0.7)",
                padding: "3px 8px",
                borderRadius: 999,
              }}
            >
              📍 {article.suburb}
            </span>
          </div>
          <div
            style={{
              padding: "14px 16px 16px",
              display: "flex",
              flexDirection: "column",
              flex: 1,
            }}
          >
            <div
              style={{
                fontSize: 14.5,
                fontWeight: 800,
                color: "#0f172a",
                lineHeight: 1.35,
                marginBottom: 6,
              }}
            >
              {article.title}
            </div>
            <div
              style={{
                fontSize: 12.5,
                color: "#64748b",
                lineHeight: 1.55,
                flex: 1,
              }}
            >
              {article.snippet}
            </div>
            <div
              style={{
                marginTop: 12,
                paddingTop: 10,
                borderTop: "1px solid #f1f5f9",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                fontSize: 11,
                color: "#64748b",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <span
                  style={{
                    width: 18,
                    height: 18,
                    borderRadius: "50%",
                    background: agentColor,
                    color: "#fff",
                    fontSize: 9,
                    fontWeight: 800,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  JD
                </span>
                <span style={{ fontWeight: 600 }}>Demo Agency</span>
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                <span>{article.minutes} min</span>
                <span
                  key={views}
                  style={{ animation: "countTick 0.3s ease", display: "inline-flex", gap: 3 }}
                >
                  👁 {views.toLocaleString()}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* BACK */}
        <div
          style={{
            ...faceStyle,
            transform: "rotateY(180deg)",
            background: `linear-gradient(140deg, ${article.badgeColor} 0%, #0f172a 95%)`,
            color: "#fff",
            padding: "16px 16px 12px",
            justifyContent: "space-between",
          }}
        >
          <div>
            <div
              style={{
                fontSize: 9,
                fontWeight: 800,
                letterSpacing: 1,
                opacity: 0.85,
                textTransform: "uppercase",
                marginBottom: 6,
              }}
            >
              {article.badge}
            </div>
            <div
              style={{
                fontSize: 13,
                fontWeight: 800,
                lineHeight: 1.3,
                marginBottom: 10,
              }}
            >
              What this article does for you
            </div>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {(article.pitch || []).map((p) => (
                <li
                  key={p}
                  style={{
                    display: "flex",
                    gap: 6,
                    alignItems: "flex-start",
                    fontSize: 11.5,
                    lineHeight: 1.45,
                    marginBottom: 6,
                  }}
                >
                  <span style={{ color: BRAND_ACCENT_COLOR, fontWeight: 900 }}>✓</span>
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </div>
          <div
            style={{
              fontSize: 10.5,
              fontWeight: 700,
              letterSpacing: 0.5,
              opacity: 0.7,
              textAlign: "center",
              paddingTop: 12,
              borderTop: "1px solid rgba(255,255,255,0.15)",
            }}
          >
            Click to flip back
          </div>
        </div>
      </div>
    </div>
  );
}

/* ─────────── Article grid (animated) ─────────── */
function ArticleGrid({ isMobile }) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
        gap: 20,
      }}
    >
      {ARTICLE_LIBRARY.map((a, i) => (
        <ArticleCard key={a.title} article={a} delay={i * 120} />
      ))}
    </div>
  );
}

/* ─────────── Topic cards ─────────── */
function TopicGrid({ isMobile }) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(6, 1fr)",
        gap: 12,
      }}
    >
      {TOPIC_CARDS.map((t, i) => (
        <div
          key={t.label}
          style={{
            background: "#fff",
            border: "1px solid #e2e8f0",
            borderRadius: 12,
            padding: "16px 12px",
            textAlign: "center",
            animation: `slideInUp 0.6s ${i * 70}ms ease both`,
            boxShadow: "0 2px 8px rgba(15,23,42,0.04)",
          }}
        >
          <div style={{ fontSize: 26, marginBottom: 6 }}>{t.icon}</div>
          <div
            style={{
              fontSize: 12.5,
              fontWeight: 800,
              color: BRAND_COLOR,
              marginBottom: 2,
            }}
          >
            {t.label}
          </div>
          <div style={{ fontSize: 11, color: "#64748b", lineHeight: 1.4 }}>{t.desc}</div>
        </div>
      ))}
    </div>
  );
}

/* ─────────── Generate Article workflow demo ─────────── */
const COVER_OPTIONS = [
  "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=600&q=70",
  "https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=600&q=70",
  "https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=600&q=70",
  "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=600&q=70",
];
const SUBURB_CHIPS = [
  { name: "Manly", state: "NSW" },
  { name: "Fairlight", state: "NSW" },
  { name: "Queenscliff", state: "NSW" },
];
const PROMPT_TEMPLATES = [
  {
    id: "monthly",
    label: "Monthly market update",
    prompt:
      "Write a monthly market update for Manly. Cover median prices, vacancy and the three coastal precinct upgrades. Confident tone, 4 short paragraphs.",
  },
  {
    id: "rental",
    label: "Rental trends",
    prompt:
      "Summarise rental yields, vacancy and asking-rent movements for the suburb. Aimed at landlords deciding to hold or sell.",
  },
  {
    id: "infra",
    label: "Infrastructure impact",
    prompt:
      "Explain how upcoming infrastructure projects will reshape value in the suburb over the next 18 months.",
  },
  {
    id: "top",
    label: "Top-performing streets",
    prompt:
      "List the top 5 streets by median sale price this quarter, with the two surprises that outperformed the suburb.",
  },
];
const SELECTED_TEMPLATE = PROMPT_TEMPLATES[0];

const LIBRARY_EXISTING = [
  {
    cover:
      "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=600&q=70",
    title: "Mosman: Why Rents Climbed 9.4% This Quarter",
    suburbs: ["Mosman NSW"],
    daysAgo: "5 days ago",
  },
  {
    cover:
      "https://images.unsplash.com/photo-1582407947304-fd86f028f716?auto=format&fit=crop&w=600&q=70",
    title: "Top 5 Streets in Vaucluse by Median Sale Price",
    suburbs: ["Vaucluse NSW"],
    daysAgo: "11 days ago",
  },
];

function GenerateArticleWorkflow({ isMobile }) {
  // step: 0 cover, 1 suburbs, 2 prompt, 3 generating, 4 done, 5 live in library
  const [step, setStep] = useState(0);
  const [coverIdx, setCoverIdx] = useState(null);
  const [chosenSuburbs, setChosenSuburbs] = useState([]);
  const [promptTyped, setPromptTyped] = useState("");
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let timers = [];
    const reset = () => {
      setCoverIdx(null);
      setChosenSuburbs([]);
      setPromptTyped("");
      setProgress(0);
      setStep(0);
    };

    const run = () => {
      reset();
      timers.push(setTimeout(() => setCoverIdx(1), 500));
      timers.push(setTimeout(() => setCoverIdx(2), 900));
      timers.push(setTimeout(() => setCoverIdx(0), 1300));

      timers.push(setTimeout(() => setStep(1), 1900));
      SUBURB_CHIPS.forEach((s, i) => {
        timers.push(
          setTimeout(() => {
            setChosenSuburbs((prev) => [...prev, s]);
          }, 2100 + i * 450)
        );
      });

      timers.push(setTimeout(() => setStep(2), 3700));
      const target = SELECTED_TEMPLATE.prompt;
      for (let i = 1; i <= target.length; i++) {
        timers.push(
          setTimeout(() => setPromptTyped(target.slice(0, i)), 3900 + i * 18)
        );
      }

      const genStart = 3900 + target.length * 18 + 500;
      timers.push(setTimeout(() => setStep(3), genStart));
      for (let p = 0; p <= 100; p += 2) {
        timers.push(setTimeout(() => setProgress(p), genStart + p * 40));
      }

      const doneAt = genStart + 100 * 40 + 200;
      timers.push(setTimeout(() => setStep(4), doneAt));
      timers.push(setTimeout(() => setStep(5), doneAt + 1600));

      timers.push(setTimeout(run, doneAt + 1600 + 4500));
    };

    run();
    return () => timers.forEach(clearTimeout);
  }, []);

  const stepLabels = [
    "Pick cover",
    "Pick suburbs",
    "Write prompt",
    "Generate",
    "Published",
    "Live in your library",
  ];

  const showLibrary = step >= 5;

  return (
    <div
      style={{
        background: "#0f172a",
        borderRadius: 18,
        padding: isMobile ? 14 : 22,
        border: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 30px 80px rgba(0,0,0,0.4)",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          overflow: "hidden",
          boxShadow: "0 20px 50px rgba(0,0,0,0.35)",
        }}
      >
        <div
          style={{
            background: "#f1f5f9",
            padding: "8px 12px",
            display: "flex",
            alignItems: "center",
            gap: 6,
            borderBottom: "1px solid #e2e8f0",
          }}
        >
          <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#fca5a5" }} />
          <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#fcd34d" }} />
          <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#86efac" }} />
          <div
            style={{
              marginLeft: 10,
              flex: 1,
              minWidth: 0,
              background: "#fff",
              borderRadius: 6,
              padding: "3px 10px",
              fontSize: 10.5,
              color: "#64748b",
              border: "1px solid #e2e8f0",
              fontFamily: "ui-monospace, SFMono-Regular, monospace",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            vendorleads.com.au/articles{showLibrary ? "" : " · Generate article"}
          </div>
        </div>

        {/* Step indicator */}
        <div
          style={{
            display: "flex",
            gap: 0,
            padding: "12px 16px 0",
            borderBottom: "1px solid #f1f5f9",
            overflowX: "auto",
          }}
        >
          {stepLabels.map((label, i) => {
            const isActive = step === i;
            const isDone = step > i;
            return (
              <div
                key={label}
                style={{
                  flex: 1,
                  textAlign: "center",
                  padding: "8px 4px 10px",
                  borderBottom: `2px solid ${
                    isActive ? BRAND_ACCENT_COLOR : isDone ? `${BRAND_ACCENT_COLOR}55` : "transparent"
                  }`,
                  color: isActive ? "#0f172a" : isDone ? "#64748b" : "#cbd5e1",
                  fontSize: 11.5,
                  fontWeight: 700,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 6,
                  whiteSpace: "nowrap",
                  transition: "all 0.3s ease",
                  minWidth: 80,
                }}
              >
                <span
                  style={{
                    width: 18,
                    height: 18,
                    borderRadius: "50%",
                    background: isActive
                      ? BRAND_ACCENT_COLOR
                      : isDone
                      ? `${BRAND_ACCENT_COLOR}33`
                      : "#f1f5f9",
                    color: isActive ? "#fff" : isDone ? BRAND_ACCENT_COLOR : "#94a3b8",
                    fontSize: 10,
                    fontWeight: 800,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {isDone ? "✓" : i + 1}
                </span>
                {!isMobile && label}
              </div>
            );
          })}
        </div>

        {/* Body */}
        <div style={{ padding: isMobile ? 16 : 22, minHeight: isMobile ? 520 : 640 }}>
          {!showLibrary && (
            <>
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 800,
                  color: "#94a3b8",
                  letterSpacing: 1,
                  textTransform: "uppercase",
                  marginBottom: 8,
                }}
              >
                Cover image
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, 1fr)",
                  gap: 8,
                  marginBottom: 18,
                }}
              >
                {COVER_OPTIONS.map((src, i) => {
                  const selected = coverIdx === i;
                  return (
                    <div
                      key={src}
                      style={{
                        position: "relative",
                        paddingTop: "70%",
                        borderRadius: 8,
                        overflow: "hidden",
                        border: selected
                          ? `3px solid ${BRAND_ACCENT_COLOR}`
                          : "2px solid #e2e8f0",
                        transition: "border 0.25s ease, transform 0.25s ease",
                        transform: selected ? "scale(1.02)" : "scale(1)",
                      }}
                    >
                      <img
                        src={src}
                        alt=""
                        style={{
                          position: "absolute",
                          inset: 0,
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                      {selected && (
                        <div
                          style={{
                            position: "absolute",
                            inset: 0,
                            background: "rgba(16,185,129,0.18)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <span
                            style={{
                              width: 24,
                              height: 24,
                              borderRadius: "50%",
                              background: BRAND_ACCENT_COLOR,
                              color: "#fff",
                              fontSize: 13,
                              fontWeight: 900,
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                            }}
                          >
                            ✓
                          </span>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              <div
                style={{
                  fontSize: 11,
                  fontWeight: 800,
                  color: "#94a3b8",
                  letterSpacing: 1,
                  textTransform: "uppercase",
                  marginBottom: 8,
                }}
              >
                Suburbs
              </div>
              <div
                style={{
                  border: "1.5px solid",
                  borderColor: step === 1 ? BRAND_ACCENT_COLOR : "#e5e7eb",
                  borderRadius: 10,
                  padding: "10px 12px",
                  minHeight: 46,
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  gap: 6,
                  marginBottom: 18,
                  transition: "border-color 0.3s ease",
                  boxShadow:
                    step === 1 ? `0 0 0 3px ${BRAND_ACCENT_COLOR}22` : "none",
                }}
              >
                {chosenSuburbs.map((s) => (
                  <span
                    key={s.name}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 5,
                      background: `${BRAND_ACCENT_COLOR}15`,
                      color: BRAND_ACCENT_COLOR,
                      fontSize: 12,
                      fontWeight: 700,
                      padding: "4px 10px",
                      borderRadius: 999,
                      border: `1px solid ${BRAND_ACCENT_COLOR}55`,
                      animation: "slideInRight 0.3s ease both",
                    }}
                  >
                    📍 {s.name} {s.state}
                  </span>
                ))}
                {chosenSuburbs.length === 0 && (
                  <span style={{ color: "#9ca3af", fontSize: 12.5 }}>
                    Search and add one or more suburbs
                  </span>
                )}
                {step === 1 && chosenSuburbs.length < SUBURB_CHIPS.length && (
                  <span
                    style={{
                      display: "inline-block",
                      width: 1.5,
                      height: 14,
                      background: "#0f172a",
                      animation: "caret 0.9s steps(1) infinite",
                    }}
                  />
                )}
              </div>

              <div
                style={{
                  fontSize: 11,
                  fontWeight: 800,
                  color: "#94a3b8",
                  letterSpacing: 1,
                  textTransform: "uppercase",
                  marginBottom: 8,
                }}
              >
                Prompt
              </div>
              <div
                style={{
                  border: "1.5px solid",
                  borderColor: step === 2 ? BRAND_ACCENT_COLOR : "#e5e7eb",
                  borderRadius: 10,
                  padding: "10px 12px",
                  minHeight: 64,
                  fontSize: 13,
                  color: "#0f172a",
                  lineHeight: 1.55,
                  boxShadow:
                    step === 2 ? `0 0 0 3px ${BRAND_ACCENT_COLOR}22` : "none",
                  transition: "border-color 0.3s ease",
                  marginBottom: 10,
                }}
              >
                {promptTyped || (
                  <span style={{ color: "#9ca3af" }}>
                    Tell the AI what to write about, or pick a template below…
                  </span>
                )}
                {step === 2 && promptTyped.length < SELECTED_TEMPLATE.prompt.length && (
                  <span
                    style={{
                      display: "inline-block",
                      width: 1.5,
                      height: 14,
                      background: "#0f172a",
                      verticalAlign: "middle",
                      marginLeft: 2,
                      animation: "caret 0.9s steps(1) infinite",
                    }}
                  />
                )}
              </div>

              {/* Prompt templates */}
              <div
                style={{
                  fontSize: 10,
                  fontWeight: 800,
                  color: "#94a3b8",
                  letterSpacing: 1,
                  textTransform: "uppercase",
                  marginBottom: 6,
                }}
              >
                Quick prompts
              </div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 6,
                  marginBottom: 18,
                }}
              >
                {PROMPT_TEMPLATES.map((t) => {
                  const isPicked = step >= 2 && t.id === SELECTED_TEMPLATE.id;
                  return (
                    <span
                      key={t.id}
                      style={{
                        fontSize: 11.5,
                        fontWeight: 700,
                        padding: "5px 11px",
                        borderRadius: 999,
                        background: isPicked ? `${BRAND_BLUE}15` : "#f8fafc",
                        color: isPicked ? BRAND_BLUE : "#64748b",
                        border: `1px solid ${
                          isPicked ? `${BRAND_BLUE}55` : "#e2e8f0"
                        }`,
                        transition: "all 0.3s ease",
                      }}
                    >
                      {isPicked && "✓ "}
                      {t.label}
                    </span>
                  );
                })}
              </div>

              <button
                style={{
                  width: "100%",
                  background:
                    step >= 4
                      ? BRAND_ACCENT_COLOR
                      : `linear-gradient(90deg, ${BRAND_ACCENT_COLOR}, ${BRAND_BLUE})`,
                  color: "#fff",
                  border: "none",
                  borderRadius: 10,
                  padding: "12px 14px",
                  fontSize: 14,
                  fontWeight: 800,
                  cursor: "default",
                  boxShadow: `0 6px 18px ${BRAND_ACCENT_COLOR}50`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  position: "relative",
                  overflow: "hidden",
                  transform: step === 3 && progress < 4 ? "scale(0.985)" : "scale(1)",
                  transition: "transform 0.15s ease",
                }}
              >
                {step < 3 && <>✨ Generate article</>}
                {step === 3 && (
                  <>
                    <span
                      style={{
                        width: 14,
                        height: 14,
                        borderRadius: "50%",
                        border: "2px solid rgba(255,255,255,0.4)",
                        borderTopColor: "#fff",
                        animation: "shimmer 0.8s linear infinite",
                      }}
                    />
                    Agent is writing… {progress}%
                  </>
                )}
                {step >= 4 && <>✓ Article published live</>}
                {step === 3 && (
                  <div
                    style={{
                      position: "absolute",
                      left: 0,
                      bottom: 0,
                      height: 3,
                      width: `${progress}%`,
                      background: "rgba(255,255,255,0.85)",
                      transition: "width 0.05s linear",
                    }}
                  />
                )}
              </button>

              {step >= 3 && (
                <div
                  style={{
                    marginTop: 14,
                    background: "#0b1220",
                    borderRadius: 10,
                    padding: "10px 14px",
                    fontFamily: "ui-monospace, SFMono-Regular, monospace",
                    fontSize: 11.5,
                    color: "#cbd5e1",
                    lineHeight: 1.7,
                    animation: "fadeIn 0.3s ease both",
                  }}
                >
                  {[
                    [10, "data.sales", "fetching Manly sales · median, volume, growth"],
                    [25, "data.rentals", "fetching rentals · yields, vacancy"],
                    [40, "data.infra", "fetching infrastructure pipeline"],
                    [55, "ai.draft", "drafting headline"],
                    [75, "ai.body", "writing body · 4 paragraphs"],
                    [95, "publish", "publishing under Demo Agency brand"],
                  ]
                    .filter(([t]) => progress >= t || step >= 4)
                    .slice(-4)
                    .map(([t, tag, msg]) => (
                      <div key={tag + t} style={{ display: "flex", gap: 10 }}>
                        <span style={{ color: "#64748b", flexShrink: 0 }}>›</span>
                        <span
                          style={{
                            color:
                              tag.startsWith("data")
                                ? BRAND_BLUE
                                : tag.startsWith("ai")
                                ? BRAND_ACCENT_COLOR
                                : "#f59e0b",
                            fontWeight: 700,
                            minWidth: 92,
                          }}
                        >
                          [{tag}]
                        </span>
                        <span>{msg}</span>
                      </div>
                    ))}
                </div>
              )}
            </>
          )}

          {/* STEP 5: Live in your library */}
          {showLibrary && (
            <div style={{ animation: "fadeIn 0.4s ease both" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 14,
                  flexWrap: "wrap",
                  gap: 8,
                }}
              >
                <div style={{ fontSize: 16, fontWeight: 800, color: "#0f172a" }}>
                  Your articles
                </div>
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    fontSize: 11,
                    fontWeight: 800,
                    color: BRAND_ACCENT_COLOR,
                    background: `${BRAND_ACCENT_COLOR}15`,
                    padding: "4px 10px",
                    borderRadius: 999,
                    border: `1px solid ${BRAND_ACCENT_COLOR}55`,
                  }}
                >
                  <span
                    style={{
                      width: 7,
                      height: 7,
                      borderRadius: "50%",
                      background: BRAND_ACCENT_COLOR,
                      animation: "pulseDot 1.4s ease-out infinite",
                    }}
                  />
                  Just published
                </div>
              </div>

              {/* New article (highlighted) */}
              <LibraryRow
                isMobile={isMobile}
                cover={COVER_OPTIONS[0]}
                title="Manly Property Market Update, March 2026"
                suburbs={SUBURB_CHIPS.map((s) => `${s.name} ${s.state}`)}
                when="Just now"
                highlight
              />
              {LIBRARY_EXISTING.map((a) => (
                <LibraryRow
                  key={a.title}
                  isMobile={isMobile}
                  cover={a.cover}
                  title={a.title}
                  suburbs={a.suburbs}
                  when={a.daysAgo}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function LibraryRow({ cover, title, suburbs, when, highlight, isMobile }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        background: "#fff",
        border: highlight
          ? `2px solid ${BRAND_ACCENT_COLOR}`
          : "1px solid #e2e8f0",
        borderRadius: 12,
        overflow: "hidden",
        marginBottom: 10,
        boxShadow: highlight
          ? `0 12px 28px ${BRAND_ACCENT_COLOR}33`
          : "0 2px 8px rgba(15,23,42,0.04)",
        animation: highlight ? "slideInDown 0.45s ease both" : undefined,
        position: "relative",
      }}
    >
      <div
        style={{
          position: "relative",
          width: isMobile ? "100%" : 160,
          height: isMobile ? 120 : 110,
          flexShrink: 0,
          background: "#f3f4f6",
        }}
      >
        <img
          src={cover}
          alt=""
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
        <span
          style={{
            position: "absolute",
            top: 8,
            left: 8,
            fontSize: 10,
            fontWeight: 800,
            padding: "3px 9px",
            borderRadius: 999,
            background: "rgba(34,197,94,0.85)",
            color: "#fff",
            letterSpacing: 0.3,
            backdropFilter: "blur(4px)",
          }}
        >
          Live
        </span>
      </div>
      <div
        style={{
          padding: "12px 14px",
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: 6,
        }}
      >
        <div style={{ fontSize: 14, fontWeight: 800, color: "#0f172a", lineHeight: 1.3 }}>
          {title}
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
          {suburbs.map((s) => (
            <span
              key={s}
              style={{
                fontSize: 10.5,
                fontWeight: 700,
                color: "#475569",
                background: "#f1f5f9",
                padding: "2px 8px",
                borderRadius: 999,
              }}
            >
              📍 {s}
            </span>
          ))}
        </div>
        <div style={{ fontSize: 11.5, color: "#94a3b8", fontWeight: 600 }}>
          Demo Agency · {when}
        </div>
      </div>
    </div>
  );
}

/* ─────────── Article scroll preview + lead-capture popup ─────────── */
const PREVIEW_PARAGRAPHS = [
  "Manly closed March with median house values at $4.62M, defying broader Sydney softness and reaffirming the suburb's place at the top of the lower north shore charts.",
  "Rental conditions tightened sharply through the quarter. Vacancy slipped to 1.1% and median asking rents rose 9.4% year on year, keeping yield-focused investors active.",
  "Three confirmed coastal precinct upgrades are forecast to lift values across Fairlight and Queenscliff over the next 18 months. New ferry capacity and pedestrianised foreshore works are already moving foot traffic, and prices, in their favour.",
  "Sales volumes lifted 12% on the December quarter as long-held family homes returned to market. Days on market dropped to 24, the lowest reading since spring.",
  "For homeowners, the data points to one clear conclusion: equity is quietly building, and timing matters. Sellers who hold off through winter may find themselves competing with a wave of new stock next spring.",
  "If you've been weighing up a move, this is the quarter to get a current valuation in front of you. The market is rewarding sellers who price to today's data, not last year's.",
];

const CONFETTI_PIECES = Array.from({ length: 32 }).map((_, i) => ({
  id: i,
  left: Math.random() * 100,
  delay: Math.random() * 0.3,
  duration: 1.6 + Math.random() * 1.2,
  rotate: Math.random() * 360,
  color: ["#10b981", "#3b82f6", "#f59e0b", "#ec4899", "#8b5cf6"][i % 5],
}));

function Confetti() {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        overflow: "hidden",
        zIndex: 10,
      }}
    >
      {CONFETTI_PIECES.map((p) => (
        <span
          key={p.id}
          style={{
            position: "absolute",
            top: -10,
            left: `${p.left}%`,
            width: 8,
            height: 12,
            background: p.color,
            transform: `rotate(${p.rotate}deg)`,
            animation: `confettiFall ${p.duration}s ${p.delay}s ease-in forwards`,
            borderRadius: 2,
            opacity: 0.95,
          }}
        />
      ))}
    </div>
  );
}

function ArticleScrollPreview({ isMobile }) {
  // phases: scrolling → popup → typing → success → reset
  const [phase, setPhase] = useState("scrolling");
  const [scroll, setScroll] = useState(0);
  const [emailTyped, setEmailTyped] = useState("");
  const [addressTyped, setAddressTyped] = useState("");
  const popupEmail = "olivia.s@gmail.com";
  const popupAddress = "12 Marine Parade, Manly NSW";

  // Smooth scroll until ~55%, then trigger popup and stop
  useEffect(() => {
    if (phase !== "scrolling") return;
    let raf;
    let cancelled = false;
    let last = performance.now();
    const tick = (now) => {
      if (cancelled) return;
      const dt = now - last;
      last = now;
      setScroll((s) => {
        const target = 55;
        const next = s + (dt / 1000) * 26;
        if (next >= target) {
          setPhase("popup");
          return target;
        }
        return next;
      });
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => {
      cancelled = true;
      cancelAnimationFrame(raf);
    };
  }, [phase]);

  // After popup appears, type email then address, then submit, then reset
  useEffect(() => {
    if (phase !== "popup") return;
    const timers = [];
    timers.push(setTimeout(() => setPhase("typing-email"), 700));
    return () => timers.forEach(clearTimeout);
  }, [phase]);

  useEffect(() => {
    if (phase !== "typing-email") return;
    let i = 0;
    let cancelled = false;
    const tick = () => {
      if (cancelled) return;
      i++;
      setEmailTyped(popupEmail.slice(0, i));
      if (i < popupEmail.length) setTimeout(tick, 65);
      else setTimeout(() => !cancelled && setPhase("typing-address"), 350);
    };
    const start = setTimeout(tick, 250);
    return () => {
      cancelled = true;
      clearTimeout(start);
    };
  }, [phase]);

  useEffect(() => {
    if (phase !== "typing-address") return;
    let i = 0;
    let cancelled = false;
    const tick = () => {
      if (cancelled) return;
      i++;
      setAddressTyped(popupAddress.slice(0, i));
      if (i < popupAddress.length) setTimeout(tick, 55);
      else setTimeout(() => !cancelled && setPhase("submitting"), 400);
    };
    const start = setTimeout(tick, 250);
    return () => {
      cancelled = true;
      clearTimeout(start);
    };
  }, [phase]);

  useEffect(() => {
    if (phase !== "submitting") return;
    const t = setTimeout(() => setPhase("success"), 600);
    return () => clearTimeout(t);
  }, [phase]);

  useEffect(() => {
    if (phase !== "success") return;
    const t = setTimeout(() => {
      setScroll(0);
      setEmailTyped("");
      setAddressTyped("");
      setPhase("scrolling");
    }, 3200);
    return () => clearTimeout(t);
  }, [phase]);

  const frameHeight = isMobile ? 520 : 600;
  const contentMaxTranslate = 380;
  const contentTranslate = -((scroll / 100) * contentMaxTranslate);
  const popupVisible = phase !== "scrolling";
  const isSuccess = phase === "success";

  return (
    <>
      <style>{`
        @keyframes confettiFall {
          0%   { transform: translateY(-10px) rotate(0deg); opacity: 1; }
          100% { transform: translateY(${frameHeight + 40}px) rotate(540deg); opacity: 0.85; }
        }
      `}</style>
      <div
        style={{
          background: "#0f172a",
          borderRadius: 18,
          padding: isMobile ? 14 : 22,
          border: "1px solid rgba(255,255,255,0.08)",
          boxShadow: "0 30px 80px rgba(0,0,0,0.4)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
            backgroundSize: "40px 40px",
            pointerEvents: "none",
          }}
        />

        <div
          style={{
            position: "relative",
            background: "#fff",
            borderRadius: 12,
            overflow: "hidden",
            boxShadow: "0 20px 50px rgba(0,0,0,0.35)",
          }}
        >
          <div
            style={{
              background: "#f1f5f9",
              padding: "8px 12px",
              display: "flex",
              alignItems: "center",
              gap: 6,
              borderBottom: "1px solid #e2e8f0",
            }}
          >
            <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#fca5a5" }} />
            <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#fcd34d" }} />
            <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#86efac" }} />
            <div
              style={{
                marginLeft: 10,
                flex: 1,
                minWidth: 0,
                background: "#fff",
                borderRadius: 6,
                padding: "3px 10px",
                fontSize: 10.5,
                color: "#64748b",
                border: "1px solid #e2e8f0",
                fontFamily: "ui-monospace, SFMono-Regular, monospace",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              demo-agency.homeprice.site/news/manly-property-market-update-march-2026
            </div>
          </div>

          <div style={{ position: "relative", height: frameHeight, overflow: "hidden", background: "#fff" }}>
            <div
              style={{
                transform: `translateY(${contentTranslate}px)`,
                transition: "transform 0.08s linear",
                padding: isMobile ? "0 18px 30px" : "0 36px 40px",
              }}
            >
              <img
                src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=70"
                alt="Manly"
                style={{
                  width: "100%",
                  height: 220,
                  objectFit: "cover",
                  display: "block",
                  borderRadius: 4,
                  marginTop: 20,
                  marginBottom: 18,
                }}
              />
              <div style={{ display: "flex", alignItems: "center", color: "#888", fontSize: 13, marginBottom: 10 }}>
                <span>Mar 28 2026</span>
                <span style={{ margin: "0 8px" }}>·</span>
                <span>4 min read</span>
              </div>
              <h1
                style={{
                  fontSize: isMobile ? 22 : 28,
                  fontWeight: 800,
                  color: "#0f172a",
                  lineHeight: 1.2,
                  margin: "0 0 18px",
                }}
              >
                Manly Property Market Update, March 2026
              </h1>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  padding: "10px 0",
                  borderTop: "1px solid #eef2f7",
                  borderBottom: "1px solid #eef2f7",
                  marginBottom: 22,
                }}
              >
                <img
                  src={DEMO_AGENCY.profile_image_url}
                  alt="John Doe"
                  style={{
                    width: 44,
                    height: 44,
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "2px solid #eee",
                    flexShrink: 0,
                    background: "#e5e7eb",
                  }}
                />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: "#0f172a" }}>John Doe</div>
                  <div style={{ fontSize: 12, color: "#888" }}>Licensed Agent · Demo Agency</div>
                </div>
                <img
                  src={DEMO_AGENCY.logo_url}
                  alt="Demo Agency"
                  style={{ height: 32, maxWidth: 110, objectFit: "contain" }}
                />
              </div>
              {PREVIEW_PARAGRAPHS.map((p, i) => (
                <p
                  key={i}
                  style={{
                    fontSize: 15,
                    color: "#334155",
                    lineHeight: 1.75,
                    margin: "0 0 18px",
                  }}
                >
                  {p}
                </p>
              ))}
            </div>

            {/* Scroll progress bar */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: 3,
                background: "#f1f5f9",
              }}
            >
              <div
                style={{
                  height: "100%",
                  width: `${scroll}%`,
                  background: `linear-gradient(90deg, ${BRAND_ACCENT_COLOR}, ${BRAND_BLUE})`,
                  transition: "width 0.08s linear",
                }}
              />
            </div>

            {/* Popup */}
            {popupVisible && (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background: "rgba(15,23,42,0.55)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 16,
                  animation: "fadeIn 0.3s ease both",
                  zIndex: 5,
                }}
              >
                <div
                  style={{
                    position: "relative",
                    background: "#fff",
                    borderRadius: 16,
                    width: "100%",
                    maxWidth: 360,
                    maxHeight: "100%",
                    padding: isMobile ? "16px 16px 14px" : "22px 22px 18px",
                    boxShadow: "0 30px 80px rgba(0,0,0,0.4)",
                    animation: "slideInUp 0.35s ease both",
                    overflow: "auto",
                  }}
                >
                  {isSuccess && <Confetti />}
                  {!isSuccess && (
                    <>
                      <div
                        style={{
                          fontSize: 18,
                          fontWeight: 700,
                          color: "#111",
                          marginBottom: 6,
                          paddingRight: 24,
                        }}
                      >
                        What's your home really worth?
                      </div>
                      <p style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.5, margin: "0 0 14px" }}>
                        Get a free AI-powered property report delivered to your inbox in minutes.
                      </p>
                      <ul style={{ listStyle: "none", paddingLeft: 0, margin: "0 0 16px" }}>
                        {[
                          "Estimated value based on comparable sales",
                          "Rental yield and suburb price trends",
                          "AI market summary and days-on-market",
                        ].map((t) => (
                          <li
                            key={t}
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              gap: 8,
                              fontSize: 13,
                              color: "#374151",
                              marginBottom: 8,
                            }}
                          >
                            <span style={{ color: BRAND_ACCENT_COLOR, fontWeight: 800 }}>✓</span>
                            <span>{t}</span>
                          </li>
                        ))}
                      </ul>
                      <div
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: 12,
                          padding: "12px 14px",
                          fontSize: 13,
                          color: "#0f172a",
                          marginBottom: 10,
                          minHeight: 42,
                        }}
                      >
                        {emailTyped || <span style={{ color: "#9ca3af" }}>Your email address</span>}
                        {phase === "typing-email" && emailTyped.length < popupEmail.length && (
                          <span
                            style={{
                              display: "inline-block",
                              width: 1.5,
                              height: 14,
                              background: "#0f172a",
                              verticalAlign: "middle",
                              marginLeft: 2,
                              animation: "caret 0.9s steps(1) infinite",
                            }}
                          />
                        )}
                      </div>
                      <div
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: 12,
                          padding: "12px 14px",
                          fontSize: 13,
                          color: addressTyped ? "#0f172a" : "#9ca3af",
                          marginBottom: 10,
                          minHeight: 42,
                        }}
                      >
                        {addressTyped || "Search your property address"}
                        {phase === "typing-address" && addressTyped.length < popupAddress.length && (
                          <span
                            style={{
                              display: "inline-block",
                              width: 1.5,
                              height: 14,
                              background: "#0f172a",
                              verticalAlign: "middle",
                              marginLeft: 2,
                              animation: "caret 0.9s steps(1) infinite",
                            }}
                          />
                        )}
                      </div>
                      <button
                        style={{
                          width: "100%",
                          background: BRAND_ACCENT_COLOR,
                          color: "#fff",
                          border: "none",
                          borderRadius: 12,
                          padding: "12px 14px",
                          fontSize: 14,
                          fontWeight: 700,
                          boxShadow: `0 4px 16px ${BRAND_ACCENT_COLOR}50`,
                          cursor: "default",
                          transform: phase === "submitting" ? "scale(0.97)" : "scale(1)",
                          transition: "transform 0.15s ease",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 8,
                        }}
                      >
                        {phase === "submitting" ? (
                          <>
                            <span
                              style={{
                                width: 14,
                                height: 14,
                                borderRadius: "50%",
                                border: "2px solid rgba(255,255,255,0.4)",
                                borderTopColor: "#fff",
                                animation: "shimmer 0.8s linear infinite",
                              }}
                            />
                            Sending…
                          </>
                        ) : (
                          "Send me my free report"
                        )}
                      </button>
                      <p style={{ fontSize: 11, color: "#9ca3af", textAlign: "center", margin: "10px 0 0" }}>
                        Free forever. No spam. Unsubscribe anytime.
                      </p>
                    </>
                  )}
                  {isSuccess && (
                    <div style={{ textAlign: "center", padding: "10px 4px 4px" }}>
                      <div
                        style={{
                          width: 56,
                          height: 56,
                          borderRadius: "50%",
                          background: BRAND_ACCENT_COLOR,
                          color: "#fff",
                          fontSize: 28,
                          fontWeight: 900,
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "8px auto 16px",
                          boxShadow: `0 8px 24px ${BRAND_ACCENT_COLOR}55`,
                          animation: "slideInUp 0.4s ease both",
                        }}
                      >
                        ✓
                      </div>
                      <div
                        style={{
                          fontSize: 18,
                          fontWeight: 800,
                          color: "#0f172a",
                          marginBottom: 6,
                        }}
                      >
                        Report is on its way 🎉
                      </div>
                      <p style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.5, margin: "0 0 8px" }}>
                        We've emailed olivia.s@gmail.com a full report on 12 Marine Parade. Demo Agency will be in touch.
                      </p>
                      <div
                        style={{
                          marginTop: 12,
                          fontSize: 11,
                          fontWeight: 800,
                          letterSpacing: 0.5,
                          color: BRAND_ACCENT_COLOR,
                          textTransform: "uppercase",
                        }}
                      >
                        ✉ New lead captured for Demo Agency
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        <div
          style={{
            marginTop: 14,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            color: "rgba(255,255,255,0.7)",
            fontSize: 12,
            fontWeight: 600,
            flexWrap: "wrap",
            gap: 8,
          }}
        >
          <span>
            ▶ Live preview · article rendered under{" "}
            <span style={{ color: BRAND_ACCENT_COLOR }}>Demo Agency</span> branding
          </span>
          <span>Popup fires after the reader scrolls past the fold</span>
        </div>
      </div>
    </>
  );
}

/* ─────────── Facebook flow demo ─────────── */
const FB_BLURB =
  "🏡 Manly's median house price climbed to $4.62M in March while rental vacancies tightened to 1.1%. Three coastal precinct upgrades are about to reshape value across Fairlight and Queenscliff, and homeowners stand to benefit.\n\nFull breakdown ↓";

function FacebookFlowDemo({ isMobile }) {
  // 0 connect, 1 blurb, 2 post, 3 live
  const [step, setStep] = useState(0);
  const [blurbTyped, setBlurbTyped] = useState("");
  const [likes, setLikes] = useState(0);
  const [comments, setComments] = useState(0);
  const [shares, setShares] = useState(0);

  useEffect(() => {
    let timers = [];
    const reset = () => {
      setStep(0);
      setBlurbTyped("");
      setLikes(0);
      setComments(0);
      setShares(0);
    };
    const run = () => {
      reset();
      // Step 0 → 1: connect Facebook (1.6s on connect)
      timers.push(setTimeout(() => setStep(1), 1700));
      // Type blurb
      const target = FB_BLURB;
      for (let i = 1; i <= target.length; i++) {
        timers.push(setTimeout(() => setBlurbTyped(target.slice(0, i)), 1900 + i * 14));
      }
      const blurbDone = 1900 + target.length * 14;
      // Step 2: post
      timers.push(setTimeout(() => setStep(2), blurbDone + 400));
      // Step 3: live
      timers.push(setTimeout(() => setStep(3), blurbDone + 1400));
      // Engagement counters tick up
      let tickStart = blurbDone + 1500;
      for (let n = 1; n <= 60; n++) {
        timers.push(
          setTimeout(() => {
            setLikes((l) => l + (Math.random() < 0.7 ? 1 : 0));
            setComments((c) => c + (Math.random() < 0.25 ? 1 : 0));
            setShares((s) => s + (Math.random() < 0.2 ? 1 : 0));
          }, tickStart + n * 90)
        );
      }
      // Loop
      timers.push(setTimeout(run, tickStart + 60 * 90 + 1800));
    };
    run();
    return () => timers.forEach(clearTimeout);
  }, []);

  const stepLabels = ["Connect Facebook", "Generate blurb", "Post it", "Live on Facebook"];

  return (
    <div
      style={{
        background: "#f0f2f5",
        borderRadius: 18,
        padding: isMobile ? 14 : 22,
        border: "1px solid #e2e8f0",
        boxShadow: "0 20px 50px rgba(15,23,42,0.08)",
      }}
    >
      {/* Step indicator */}
      <div
        style={{
          display: "flex",
          gap: 8,
          marginBottom: 16,
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {stepLabels.map((label, i) => {
          const isActive = step === i;
          const isDone = step > i;
          return (
            <div
              key={label}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                fontSize: 11.5,
                fontWeight: 700,
                padding: "6px 12px",
                borderRadius: 999,
                background: isActive
                  ? BRAND_ACCENT_COLOR
                  : isDone
                  ? `${BRAND_ACCENT_COLOR}22`
                  : "#fff",
                color: isActive ? "#fff" : isDone ? BRAND_ACCENT_COLOR : "#64748b",
                border: `1px solid ${
                  isActive ? BRAND_ACCENT_COLOR : isDone ? `${BRAND_ACCENT_COLOR}55` : "#e2e8f0"
                }`,
                transition: "all 0.3s ease",
              }}
            >
              <span
                style={{
                  width: 16,
                  height: 16,
                  borderRadius: "50%",
                  background: isActive
                    ? "rgba(255,255,255,0.25)"
                    : isDone
                    ? BRAND_ACCENT_COLOR
                    : "#f1f5f9",
                  color: isActive ? "#fff" : isDone ? "#fff" : "#94a3b8",
                  fontSize: 9,
                  fontWeight: 900,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {isDone ? "✓" : i + 1}
              </span>
              {label}
            </div>
          );
        })}
      </div>

      <div
        style={{
          background: "#fff",
          borderRadius: 14,
          border: "1px solid #dee0e3",
          boxShadow: "0 4px 14px rgba(15,23,42,0.05)",
          overflow: "hidden",
          minHeight: 460,
          position: "relative",
        }}
      >
        {/* STEP 0: Connect Facebook */}
        {step === 0 && (
          <div
            style={{
              padding: "40px 24px",
              textAlign: "center",
              animation: "fadeIn 0.3s ease both",
            }}
          >
            <div
              style={{
                width: 64,
                height: 64,
                borderRadius: 14,
                background: "#1877f2",
                color: "#fff",
                fontSize: 36,
                fontWeight: 900,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
                boxShadow: "0 12px 30px rgba(24,119,242,0.35)",
              }}
            >
              f
            </div>
            <div style={{ fontSize: 18, fontWeight: 800, color: "#0f172a", marginBottom: 6 }}>
              Connect your Facebook page
            </div>
            <p style={{ fontSize: 13, color: "#64748b", margin: "0 auto 20px", maxWidth: 320 }}>
              One-time auth. We'll post articles to your page on your behalf.
            </p>
            <button
              style={{
                background: "#1877f2",
                color: "#fff",
                border: "none",
                borderRadius: 10,
                padding: "12px 22px",
                fontSize: 14,
                fontWeight: 700,
                boxShadow: "0 6px 18px rgba(24,119,242,0.35)",
                cursor: "default",
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <span
                style={{
                  width: 14,
                  height: 14,
                  borderRadius: "50%",
                  border: "2px solid rgba(255,255,255,0.4)",
                  borderTopColor: "#fff",
                  animation: "shimmer 0.8s linear infinite",
                }}
              />
              Connecting Demo Agency…
            </button>
          </div>
        )}

        {/* STEP 1: Generate blurb */}
        {step === 1 && (
          <div
            style={{
              padding: "20px 22px",
              animation: "fadeIn 0.3s ease both",
            }}
          >
            <div
              style={{
                fontSize: 11,
                fontWeight: 800,
                color: "#94a3b8",
                letterSpacing: 1,
                textTransform: "uppercase",
                marginBottom: 8,
              }}
            >
              ✨ AI generating Facebook post
            </div>
            <div
              style={{
                background: "#0f172a",
                borderRadius: 10,
                padding: "16px 18px",
                color: "#e2e8f0",
                fontSize: 13,
                lineHeight: 1.65,
                whiteSpace: "pre-wrap",
                fontFamily: "ui-monospace, SFMono-Regular, monospace",
                minHeight: 220,
              }}
            >
              {blurbTyped}
              <span
                style={{
                  display: "inline-block",
                  width: 1.5,
                  height: 14,
                  background: BRAND_ACCENT_COLOR,
                  verticalAlign: "middle",
                  marginLeft: 2,
                  animation: "caret 0.9s steps(1) infinite",
                }}
              />
            </div>
            <div
              style={{
                marginTop: 12,
                display: "flex",
                gap: 8,
                flexWrap: "wrap",
              }}
            >
              {["Suburb hook", "Stat punch", "Soft CTA"].map((t) => (
                <span
                  key={t}
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: BRAND_ACCENT_COLOR,
                    background: `${BRAND_ACCENT_COLOR}15`,
                    border: `1px solid ${BRAND_ACCENT_COLOR}55`,
                    padding: "4px 10px",
                    borderRadius: 999,
                  }}
                >
                  ✓ {t}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* STEP 2: Posting */}
        {step === 2 && (
          <div
            style={{
              padding: "40px 24px",
              textAlign: "center",
              animation: "fadeIn 0.3s ease both",
            }}
          >
            <div
              style={{
                width: 64,
                height: 64,
                borderRadius: "50%",
                background: BRAND_ACCENT_COLOR,
                color: "#fff",
                fontSize: 28,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
                animation: "pulseDot 1.2s ease-out infinite",
              }}
            >
              ↗
            </div>
            <div style={{ fontSize: 18, fontWeight: 800, color: "#0f172a", marginBottom: 6 }}>
              Posting to Demo Agency's Facebook page…
            </div>
            <p style={{ fontSize: 13, color: "#64748b", margin: 0 }}>
              Blurb, cover image and link are on their way.
            </p>
          </div>
        )}

        {/* STEP 3: Live on Facebook */}
        {step === 3 && (
          <div
            style={{
              padding: isMobile ? 14 : 18,
              animation: "fadeIn 0.3s ease both",
            }}
          >
            <div
              style={{
                background: "#fff",
                border: "1px solid #dee0e3",
                borderRadius: 8,
              }}
            >
              <div
                style={{
                  padding: "12px 14px",
                  display: "flex",
                  gap: 10,
                  alignItems: "center",
                }}
              >
                <img
                  src={DEMO_AGENCY.profile_image_url}
                  alt="John Doe"
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    objectFit: "cover",
                    background: "#e5e7eb",
                  }}
                />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "#050505" }}>
                    Demo Agency
                  </div>
                  <div style={{ fontSize: 11, color: "#65676b" }}>
                    Just now · 🌐
                  </div>
                </div>
                <span
                  style={{
                    fontSize: 9.5,
                    fontWeight: 800,
                    color: BRAND_ACCENT_COLOR,
                    background: `${BRAND_ACCENT_COLOR}15`,
                    padding: "3px 8px",
                    borderRadius: 999,
                    letterSpacing: 0.5,
                  }}
                >
                  ● LIVE
                </span>
              </div>
              <div
                style={{
                  padding: "0 14px 12px",
                  fontSize: 13,
                  color: "#050505",
                  lineHeight: 1.55,
                  whiteSpace: "pre-wrap",
                }}
              >
                {FB_BLURB}
              </div>
              <div
                style={{
                  borderTop: "1px solid #f0f2f5",
                  borderBottom: "1px solid #f0f2f5",
                  background: "#f7f8fa",
                }}
              >
                <img
                  src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=900&q=70"
                  alt=""
                  style={{
                    width: "100%",
                    height: 140,
                    objectFit: "cover",
                    display: "block",
                  }}
                />
                <div style={{ padding: "10px 14px" }}>
                  <div style={{ fontSize: 10.5, color: "#65676b", textTransform: "uppercase" }}>
                    homeprice.site
                  </div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: "#050505", marginTop: 2 }}>
                    Manly Property Market Update, March 2026
                  </div>
                  <div style={{ fontSize: 12, color: "#65676b", marginTop: 2 }}>
                    Branded to Demo Agency · 4 min read
                  </div>
                </div>
              </div>
              <div
                style={{
                  padding: "6px 14px",
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: 12,
                  color: "#65676b",
                }}
              >
                <span>👍 ❤ {likes.toLocaleString()}</span>
                <span>
                  {comments} comments · {shares} shares
                </span>
              </div>
              <div
                style={{
                  padding: "8px 14px",
                  display: "flex",
                  justifyContent: "space-around",
                  fontSize: 12.5,
                  fontWeight: 600,
                  color: "#65676b",
                  borderTop: "1px solid #f0f2f5",
                }}
              >
                <span>👍 Like</span>
                <span>💬 Comment</span>
                <span>↗ Share</span>
              </div>
            </div>
            <div
              style={{
                marginTop: 10,
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: 8,
              }}
            >
              {[
                ["Likes", likes, "#1877f2"],
                ["Comments", comments, "#10b981"],
                ["Shares", shares, "#f59e0b"],
              ].map(([label, value, color]) => (
                <div
                  key={label}
                  style={{
                    background: "#fff",
                    border: "1px solid #e2e8f0",
                    borderRadius: 10,
                    padding: "10px 12px",
                    textAlign: "center",
                  }}
                >
                  <div
                    key={value}
                    style={{
                      fontSize: 20,
                      fontWeight: 900,
                      color,
                      letterSpacing: -0.5,
                      animation: "countTick 0.3s ease",
                    }}
                  >
                    {value.toLocaleString()}
                  </div>
                  <div
                    style={{
                      fontSize: 10,
                      fontWeight: 700,
                      color: "#64748b",
                      letterSpacing: 0.5,
                      textTransform: "uppercase",
                      marginTop: 2,
                    }}
                  >
                    {label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ─────────── Engagement chart + counters ─────────── */
function EngagementDashboard({ isMobile }) {
  const data = [
    { day: "Mon", v: 32 },
    { day: "Tue", v: 51 },
    { day: "Wed", v: 78 },
    { day: "Thu", v: 64 },
    { day: "Fri", v: 102 },
    { day: "Sat", v: 144 },
    { day: "Sun", v: 187 },
  ];
  const maxV = Math.max(...data.map((d) => d.v));

  const [views, setViews] = useState(2847);
  const [subs, setSubs] = useState(193);
  const [shares, setShares] = useState(64);

  useEffect(() => {
    const t = setInterval(() => {
      setViews((v) => v + Math.floor(Math.random() * 4) + 1);
      if (Math.random() < 0.45) setSubs((s) => s + 1);
      if (Math.random() < 0.3) setShares((s) => s + 1);
    }, 1500);
    return () => clearInterval(t);
  }, []);

  const Counter = ({ label, value, color, icon }) => (
    <div
      style={{
        background: "#fff",
        borderRadius: 14,
        border: "1px solid #e2e8f0",
        padding: "16px 18px",
        boxShadow: "0 4px 16px rgba(15,23,42,0.05)",
        display: "flex",
        alignItems: "center",
        gap: 14,
      }}
    >
      <div
        style={{
          width: 44,
          height: 44,
          borderRadius: 12,
          background: `${color}1a`,
          color,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 22,
          flexShrink: 0,
        }}
      >
        {icon}
      </div>
      <div>
        <div
          key={value}
          style={{
            fontSize: 24,
            fontWeight: 900,
            color: "#0f172a",
            letterSpacing: -0.5,
            animation: "countTick 0.3s ease",
            lineHeight: 1,
          }}
        >
          {value.toLocaleString()}
        </div>
        <div
          style={{
            fontSize: 11,
            color: "#64748b",
            fontWeight: 600,
            marginTop: 4,
            letterSpacing: 0.3,
            textTransform: "uppercase",
          }}
        >
          {label}
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
          gap: 14,
        }}
      >
        <Counter label="Total views this month" value={views} color={BRAND_BLUE} icon="👁" />
        <Counter label="New subscribers" value={subs} color={BRAND_ACCENT_COLOR} icon="✉" />
        <Counter label="Social shares" value={shares} color="#f59e0b" icon="↗" />
      </div>

      <div
        style={{
          background: "#fff",
          borderRadius: 16,
          border: "1px solid #e2e8f0",
          padding: isMobile ? "18px 16px" : "24px 28px",
          boxShadow: "0 4px 16px rgba(15,23,42,0.05)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 16,
            flexWrap: "wrap",
            gap: 8,
          }}
        >
          <div style={{ fontSize: 14, fontWeight: 800, color: BRAND_COLOR }}>
            Article views · last 7 days
          </div>
          <div
            style={{
              fontSize: 11.5,
              color: BRAND_ACCENT_COLOR,
              fontWeight: 700,
              background: "rgba(16,185,129,0.1)",
              padding: "4px 10px",
              borderRadius: 999,
            }}
          >
            ↑ 184% vs last week
          </div>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: `repeat(${data.length}, 1fr)`,
            gap: 10,
            alignItems: "end",
            height: isMobile ? 180 : 240,
            borderBottom: "1px solid #f1f5f9",
            padding: "0 4px 6px",
          }}
        >
          {data.map((d, i) => (
            <div
              key={d.day}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: 4,
                height: "100%",
              }}
            >
              <div style={{ fontSize: 10, fontWeight: 800, color: "#475569" }}>{d.v}</div>
              <div
                style={{
                  width: "55%",
                  height: `${(d.v / maxV) * 100}%`,
                  background: `linear-gradient(180deg, ${BRAND_ACCENT_COLOR}, ${BRAND_BLUE})`,
                  borderRadius: "4px 4px 0 0",
                  transformOrigin: "bottom",
                  animation: `barGrow 0.7s ${i * 60}ms ease both`,
                }}
              />
            </div>
          ))}
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: `repeat(${data.length}, 1fr)`,
            gap: 10,
            marginTop: 6,
          }}
        >
          {data.map((d) => (
            <div
              key={d.day}
              style={{ fontSize: 10.5, color: "#94a3b8", textAlign: "center" }}
            >
              {d.day}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ─────────── Section heading ─────────── */
function SectionHeading({ kicker, title, blurb, accent }) {
  return (
    <div style={{ textAlign: "center", maxWidth: 720, margin: "0 auto 2.5rem auto" }}>
      <div
        style={{
          display: "inline-block",
          fontSize: 11,
          fontWeight: 800,
          letterSpacing: 2,
          color: accent,
          background: `${accent}1a`,
          padding: "4px 12px",
          borderRadius: 999,
          marginBottom: 12,
          textTransform: "uppercase",
        }}
      >
        {kicker}
      </div>
      <h2
        style={{
          fontSize: "1.9rem",
          fontWeight: 800,
          color: BRAND_COLOR,
          margin: "0 0 0.75rem 0",
          letterSpacing: "-0.01em",
          lineHeight: 1.2,
        }}
      >
        {title}
      </h2>
      {blurb ? (
        <p style={{ color: GRAY_DARK_COLOR, fontSize: "1rem", lineHeight: 1.65, margin: 0 }}>
          {blurb}
        </p>
      ) : null}
    </div>
  );
}

/* ─────────── Marquee of suburbs (decorative) ─────────── */
function SuburbMarquee() {
  const items = [
    "Manly", "Mosman", "Double Bay", "Vaucluse", "Balmain",
    "Neutral Bay", "Cremorne", "Bondi", "Paddington", "Lane Cove",
    "Chatswood", "North Sydney", "Pyrmont", "Surry Hills", "Coogee",
  ];
  const doubled = [...items, ...items];
  return (
    <div
      style={{
        overflow: "hidden",
        padding: "14px 0",
        background: "#0f172a",
        borderTop: "1px solid rgba(255,255,255,0.06)",
        borderBottom: "1px solid rgba(255,255,255,0.06)",
        position: "relative",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: 36,
          width: "max-content",
          animation: "scroll-x 38s linear infinite",
        }}
      >
        {doubled.map((s, i) => (
          <div
            key={i}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              color: "rgba(255,255,255,0.7)",
              fontSize: 14,
              fontWeight: 700,
              letterSpacing: 0.5,
              whiteSpace: "nowrap",
            }}
          >
            <span style={{ color: BRAND_ACCENT_COLOR }}>📍</span>
            {s}
            <span style={{ color: "rgba(255,255,255,0.25)" }}>·</span>
          </div>
        ))}
      </div>
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: 80,
          background: "linear-gradient(90deg, #0f172a, transparent)",
          pointerEvents: "none",
        }}
      />
      <div
        style={{
          position: "absolute",
          right: 0,
          top: 0,
          bottom: 0,
          width: 80,
          background: "linear-gradient(270deg, #0f172a, transparent)",
          pointerEvents: "none",
        }}
      />
    </div>
  );
}

/* ─────────── Reusable CTA button ─────────── */
function CtaButton({ children, onClick, variant = "primary" }) {
  const isPrimary = variant === "primary";
  return (
    <button
      style={{
        border: isPrimary ? "none" : "1px solid rgba(255,255,255,0.25)",
        borderRadius: 8,
        padding: "0.85rem 2rem",
        fontSize: "1rem",
        fontWeight: 600,
        cursor: "pointer",
        background: isPrimary ? BRAND_ACCENT_COLOR : "rgba(255,255,255,0.08)",
        color: "#fff",
        boxShadow: isPrimary ? "0 4px 14px rgba(16,185,129,0.4)" : "none",
        transition: "transform 0.15s, box-shadow 0.15s, background 0.15s",
      }}
      onClick={onClick}
      onMouseOver={(e) => {
        if (isPrimary) {
          e.currentTarget.style.transform = "translateY(-1px)";
          e.currentTarget.style.boxShadow = "0 6px 20px rgba(16,185,129,0.5)";
        } else {
          e.currentTarget.style.background = "rgba(255,255,255,0.15)";
        }
      }}
      onMouseOut={(e) => {
        if (isPrimary) {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 14px rgba(16,185,129,0.4)";
        } else {
          e.currentTarget.style.background = "rgba(255,255,255,0.08)";
        }
      }}
    >
      {children}
    </button>
  );
}

/* ─────────── Main page ─────────── */
export default function AINewsArticles() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false
  );
  const [showContact, setShowContact] = useState(false);
  const [showSignIn, setShowSignIn] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ fontFamily: "Inter, Arial, sans-serif", background: "#fff" }}>
      <GlobalAnimations />
      <Navbar onSignIn={() => setShowSignIn(true)} />

      {/* ─────────── HERO ─────────── */}
      <header
        style={{
          background: "linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #134e4a 100%)",
          padding: isMobile ? "3.5rem 1.25rem 4rem" : "5.5rem 2rem 6rem",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
            backgroundSize: "60px 60px",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            maxWidth: 1180,
            margin: "0 auto",
            position: "relative",
            zIndex: 1,
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "1fr 1.05fr",
            alignItems: "center",
            gap: isMobile ? "2.5rem" : "3.5rem",
          }}
        >
          <div>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                background: "rgba(16,185,129,0.15)",
                border: "1px solid rgba(16,185,129,0.3)",
                color: BRAND_ACCENT_COLOR,
                fontSize: "0.85rem",
                fontWeight: 700,
                borderRadius: 999,
                padding: "0.4rem 1rem",
                marginBottom: "1.5rem",
                letterSpacing: "0.04em",
                textTransform: "uppercase",
              }}
            >
              <span
                style={{
                  width: 7,
                  height: 7,
                  borderRadius: "50%",
                  background: BRAND_ACCENT_COLOR,
                  animation: "pulseDot 1.4s ease-out infinite",
                }}
              />
              AI News Articles
            </div>
            <h1
              style={{
                fontSize: isMobile ? "2.1rem" : "3rem",
                fontWeight: 900,
                marginBottom: "1.25rem",
                lineHeight: 1.1,
                color: "#fff",
                letterSpacing: "-0.025em",
              }}
            >
              Be the{" "}
              <span
                style={{
                  background: `linear-gradient(90deg, ${BRAND_ACCENT_COLOR}, ${BRAND_BLUE})`,
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  color: "transparent",
                }}
              >
                suburb expert
              </span>{" "}
              your database can't stop sharing.
            </h1>
            <p
              style={{
                fontSize: isMobile ? "1rem" : "1.15rem",
                color: "rgba(255,255,255,0.75)",
                marginBottom: "1.75rem",
                lineHeight: 1.65,
                maxWidth: 520,
              }}
            >
              AI writes deeply local market articles under your brand. Sales, rentals, infrastructure, suburb profiles, ready to share on socials and send to your database. Show up every week as the agent who knows the market cold.
            </p>
            <div
              style={{
                display: "flex",
                gap: "0.75rem",
                flexDirection: isMobile ? "column" : "row",
                alignItems: isMobile ? "stretch" : "center",
                marginBottom: "1.75rem",
              }}
            >
              <CtaButton onClick={() => setShowSignIn(true)}>Start writing</CtaButton>
              <a
                href="https://homeprice.site/news/liverpool-property-market-update-march-2026-prices-hold-firm-rental-demand-surges-despite-slower-sales-45?agent=demo-agency"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  border: "1px solid rgba(255,255,255,0.25)",
                  borderRadius: 8,
                  padding: "0.85rem 2rem",
                  fontSize: "1rem",
                  fontWeight: 600,
                  background: "rgba(255,255,255,0.08)",
                  color: "#fff",
                  textDecoration: "none",
                  textAlign: "center",
                  transition: "background 0.15s",
                }}
                onMouseOver={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.15)")}
                onMouseOut={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.08)")}
              >
                See live article ↗
              </a>
            </div>
            <div
              style={{
                display: "flex",
                gap: isMobile ? 14 : 28,
                flexWrap: "wrap",
                color: "rgba(255,255,255,0.55)",
                fontSize: 12.5,
                fontWeight: 600,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <span style={{ color: BRAND_ACCENT_COLOR }}>✓</span> Real local data
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <span style={{ color: BRAND_ACCENT_COLOR }}>✓</span> Branded to you
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <span style={{ color: BRAND_ACCENT_COLOR }}>✓</span> Lead capture built in
              </div>
            </div>
          </div>
          <div style={{ minWidth: 0 }}>
            <AIWritingHero isMobile={isMobile} />
          </div>
        </div>
      </header>

      <SuburbMarquee />

      {/* ─────────── Topic spectrum ─────────── */}
      <section
        style={{
          padding: isMobile ? "3rem 1.5rem" : "5rem 2rem",
          background: "#f8fafc",
          borderBottom: "1px solid #eef2f7",
        }}
      >
        <SectionHeading
          kicker="Six topic engines"
          accent={BRAND_ACCENT_COLOR}
          title="One platform. Every angle on the local market."
        />
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <TopicGrid isMobile={isMobile} />
        </div>
      </section>

      {/* ─────────── Article library showcase ─────────── */}
      <section
        style={{
          padding: isMobile ? "3rem 1.5rem" : "5rem 2rem",
          background: "#fff",
        }}
      >
        <SectionHeading
          kicker="Sample library"
          accent={BRAND_BLUE}
          title="Articles your readers will actually finish"
          blurb="Each one branded to your agency, packed with local stats, and complete with cover image, byline and share-ready summary."
        />
        <div style={{ maxWidth: 1180, margin: "0 auto" }}>
          <ArticleGrid isMobile={isMobile} />
        </div>
      </section>

      {/* ─────────── Suburb targeting ─────────── */}
      <section
        style={{
          padding: isMobile ? "3rem 1.5rem" : "5rem 2rem",
          background: "#f8fafc",
          borderTop: "1px solid #eef2f7",
          borderBottom: "1px solid #eef2f7",
        }}
      >
        <SectionHeading
          kicker="Hyper-local by default"
          accent={BRAND_ACCENT_COLOR}
          title="Pick a cover, pick a suburb, hit generate."
          blurb="Four clicks inside the platform. The AI agent pulls real sales, rentals and infrastructure data, drafts the article in your tone, and ships it under your brand."
        />
        <div style={{ maxWidth: 960, margin: "0 auto" }}>
          <GenerateArticleWorkflow isMobile={isMobile} />
        </div>
      </section>

      {/* ─────────── Lead capture ─────────── */}
      <section
        style={{
          padding: isMobile ? "3rem 1.5rem" : "5rem 2rem",
          background: "#f8fafc",
          borderTop: "1px solid #eef2f7",
          borderBottom: "1px solid #eef2f7",
        }}
      >
        <SectionHeading
          kicker="Articles that capture, not just publish"
          accent={BRAND_ACCENT_COLOR}
          title="Every reader is a potential lead"
          blurb="As soon as a reader scrolls past the fold, a popup asks the question every homeowner is curious about: what's my home really worth. They get a free AI property report. You get a qualified lead. Distributing to your existing database? Toggle the popup off."
        />
        <div style={{ maxWidth: 960, margin: "0 auto" }}>
          <ArticleScrollPreview isMobile={isMobile} />
        </div>
      </section>

      {/* ─────────── Social sharing ─────────── */}
      <section
        style={{
          padding: isMobile ? "3rem 1.5rem" : "5rem 2rem",
          background: "#fff",
        }}
      >
        <SectionHeading
          kicker="Built to be shared"
          accent={BRAND_ACCENT_COLOR}
          title="Connect Facebook once. Every article posts itself."
          blurb="Auth your Facebook page, the AI writes the blurb, and your article goes live on your page with the cover image and link, ready to collect likes, comments and shares."
        />
        <div style={{ maxWidth: 760, margin: "0 auto" }}>
          <FacebookFlowDemo isMobile={isMobile} />
        </div>
      </section>

      {/* ─────────── Engagement dashboard ─────────── */}
      <section
        style={{
          padding: isMobile ? "3rem 1.5rem" : "5rem 2rem",
          background: "#f8fafc",
          borderTop: "1px solid #eef2f7",
          borderBottom: "1px solid #eef2f7",
        }}
      >
        <SectionHeading
          kicker="Every view, every share, every lead"
          accent={BRAND_BLUE}
          title="Watch your reputation compound"
          blurb="Live counters for views, subscribers and shares. The dashboard tells you which suburbs are pulling the audience, and where to write next."
        />
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <EngagementDashboard isMobile={isMobile} />
        </div>
      </section>

      {/* ─────────── CTA ─────────── */}
      <section
        style={{
          background: "linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #134e4a 100%)",
          padding: isMobile ? "3.5rem 1.5rem" : "5rem 2rem",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
            backgroundSize: "60px 60px",
            pointerEvents: "none",
          }}
        />
        <div style={{ maxWidth: 640, margin: "0 auto", position: "relative", zIndex: 1 }}>
          <h2
            style={{
              fontSize: isMobile ? "1.85rem" : "2.5rem",
              fontWeight: 900,
              color: "#fff",
              marginBottom: "1rem",
              lineHeight: 1.15,
              letterSpacing: "-0.025em",
            }}
          >
            The expert in your suburb writes articles every week.
            <br />
            <span
              style={{
                background: `linear-gradient(90deg, ${BRAND_ACCENT_COLOR}, ${BRAND_BLUE})`,
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              Be that expert.
            </span>
          </h2>
          <p
            style={{
              color: "rgba(255,255,255,0.68)",
              marginBottom: "2rem",
              fontSize: "1.1rem",
              lineHeight: 1.6,
            }}
          >
            AI does the writing. You hit publish. Readers subscribe. Leads land in your inbox while you focus on the listings.
          </p>
          <div
            style={{
              display: "flex",
              gap: 12,
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <CtaButton onClick={() => setShowSignIn(true)}>Start writing</CtaButton>
            <CtaButton onClick={() => setShowContact(true)} variant="secondary">
              Talk to us
            </CtaButton>
          </div>
        </div>
      </section>

      {showSignIn && <SignInModal show={showSignIn} onHide={() => setShowSignIn(false)} />}
      {showContact && (
        <ContactVendorleadsModal show={showContact} onHide={() => setShowContact(false)} />
      )}
    </div>
  );
}
